import CreateAccountLink from './children/CreateAccount';

type Props = {
    guestcopy?: string;
    authenticatedcopy?: string;
    customurl?: string;
};

const CustomerCenterBlockWrapper = ({ guestcopy, authenticatedcopy, customurl }: Props) => {
    return (
        <CreateAccountLink
            guestCopy={guestcopy}
            authenticatedCopy={authenticatedcopy}
            customUrl={customurl}
            btnType="secondary"
            data-block-name="customer-center"
        />
    );
};

export default CustomerCenterBlockWrapper;
